<template>
  <v-app
    :style="{
      background: 'linear-gradient(to bottom, #424141, #ffff)',
    }"
  >
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    //
  }),
};
</script>
